<template>
  <b-button class="btn_shift_reset" @click="handleResetClicked">
    リセット
    <font-awesome-icon
      icon="rotate-right"
      style="font-weight: 600; color: #6C737F; vertical-align: text-top; padding-right: 14px;"
    />
  </b-button>
</template>

<style scoped>
.alert_reset_message {
  font-size: 14px!important;
  margin-top: 150px!important;
}
.alert_reset_icon {
  position: absolute!important;
  color: #D61515!important;
  border-color: #D61515!important;
  top: 100px!important;
  left: 50%!important;
  transform: translateY(-50%) translateX(-50%)!important;
  -webkit-transform: translateY(-50%) translateX(-50%)!important;
}
.alert_reset_title {
  position: absolute!important;
  color: #D61515!important;
  font-size: 21px!important;
  width: 100%;
  background: #F5F5F5!important;
  padding: 10px 0px!important;
}
.alert_reset_button {
  width: 150px;
  padding: 5px 0px!important
}
.alert_reset_yes_button {
  color: #02B28A;
  margin-right: 10px!important
}
.alert_reset_cloase_button {
  margin: 5px!important
}
</style>

<script>
import axios from 'axios';

export default {
  name: 'BtnReset',
  components: {
  },
  props: {
    summary: {
      type: Object,
      default: () => {
        return {};
      }
    },
    year: {
      type: String,
      default: 0
    },
    month: {
      type: String,
      default: 0
    },
    office: {
      type: Object,
      default: function() {
        return {};
      }
    },
    team_id: {
      type: Number,
      default: 0,
    },
    team_name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      firstDateOfMonth: this.$dayjs(`${this.year}-${this.month}-01`).format('YYYY-MM-DD'),
      lastDateOfMonth: this.$dayjs(`${this.year}-${this.month}-01`).endOf('month').format('YYYY-MM-DD'),
    };
  },
  methods: {
    async shiftResetSwal(){
      const result =  await this.$swal({
        titleText: 'シフトをリセットしようとしています',
        html: `<span class="alert_reset_team">
          ${this.team_name}
          </span><p class="alert_reset_message">
          シフトをリセットします。すべてのデータがリセットされ、シフトパターンで指定した勤務区分と職員の希望休（希望勤務）のみが残ります。よろしいですか？<br>
          リセットする期間を指定できます。</p>
          <input type="date" id="shift-reset-start-date" value="${this.firstDateOfMonth}" >
          <input type="date" id="shift-reset-end-date" value="${this.lastDateOfMonth}" >
        `,
        preConfirm: async () => {
          const startDate = document.querySelector('#shift-reset-start-date').value;
          const endDate = document.querySelector('#shift-reset-end-date').value;

          if (!startDate || !endDate) {
            this.$swal.showValidationMessage('有効な日付を入力してください');
            return false;
          }

          if (new Date(startDate) > new Date(endDate)) {
            this.$swal.showValidationMessage('開始日は終了日より前でなければなりません');
            return false;
          }

         return {
            startDate: startDate,
            endDate: endDate,
          };
        },
        icon: 'warning',
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        customClass: {
          icon: 'alert_reset_icon',
          header: 'alert_reset_header',
          title: 'alert_reset_title',
          closeButton: 'btn_close alert_reset_cloase_button',
          confirmButton: 'btn_green_shadow alert_reset_button alert_reset_yes_button',
          cancelButton: 'btn_gray_shadow alert_reset_button',
        },
        buttonsStyling: false,
      });

      return {
        isFirstConfirmed: result.isConfirmed,
        startDate: result.value?.startDate ?? '',
        endDate: result.value?.endDate ?? '',
      };
    },
    async resetConfirmSwal(startDate, endDate){
      return await this.$swal({
        titleText: '本当にリセットしてよろしいですか？',
        html: `<p class="alert_confirm_message">
          以下の期間のシフトをリセットします。<br>
          リセットしたシフトは元に戻せなくなります。</p>
          <span class="text-danger h3">${startDate}</span>
          ～
          <span class="text-danger h3">${endDate}</span> <br>
        `,
        icon: 'warning',
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        customClass: {
          icon: 'alert_reset_icon',
          header: 'alert_reset_header',
          title: 'alert_reset_title',
          closeButton: 'btn_close alert_reset_cloase_button',
          confirmButton: 'btn_green_shadow alert_reset_button alert_reset_yes_button',
          cancelButton: 'btn_gray_shadow alert_reset_button',
        },
        buttonsStyling: false,
      });
    },
    resetShift(startDate, endDate) {
      const url = this.$route('shifts.schedule.reset', {
        year: this.year,
        month: this.month,
        office: this.office.id,
      });
      const params = {
        team_id: this.team_id,
        startDate: startDate,
        endDate: endDate,
      };

      return axios.post(url, params);
    },
    revalidatePath() {
      return this.$inertia.get(
        route('shifts.schedule', {
          year: this.year,
          month: this.month,
          office: this.office.id,
          team_id: this.team_id,
        })
      );
    },
    async handleResetClicked() {
      // シフトリセットダイアログ
      const {
        isFirstConfirmed,
        startDate,
        endDate
      } = await this.shiftResetSwal();
      
      // シフトリセットダイアログで「はい」以外の場合
      if (!isFirstConfirmed) {
        return;
      }
      
      const startDateFormatted = this.$dayjs(startDate).format('YYYY/MM/DD');
      const endDateFormatted = this.$dayjs(endDate).format('YYYY/MM/DD');

      // リセット確認ダイアログ
      const { isConfirmed : isLastConfirmed } = await this.resetConfirmSwal(startDateFormatted, endDateFormatted);

      // リセット確認ダイアログで「はい」以外の場合
      if (! isLastConfirmed) {
        return;
      }

      try {
        this.updateLoading(true);
        
        await this.resetShift(startDate, endDate);
        
        this.revalidatePath();    
      } catch (error) {
        this.updateLoading(false);

        if (error.response?.status === 422) {
          const errorMessages = Object.values(error.response.data.errors).flat().join('<br>');

          this.$swal.fire({
            icon: 'error',
            html: errorMessages,
          });
        } else {
          this.$swal.fire({
            icon: 'error',
            text: '失敗しました。しばらくたってから再試行してください。',
          });
        }
      }
    },
    updateLoading(flg) {
      EventBus.$emit('updateLoading', flg);
    },
  },
}
</script>
